module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/ig-images/ig-03-3cadfa8cfb14a2e0f986797ea66af6a7.jpg";